
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-certified/core-training",
      function () {
        return require("private-next-pages/get-certified/core-training.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-certified/core-training"])
      });
    }
  